import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state:{
        homeEvent: false
    },
    mutations:{
        setHomeEvent(state, payload) {
            state.homeEvent = payload
        }
    },
    actions:{
        setHomeEvent(context, payload) {
            context.commit('setHomeEvent', payload)
        }
    },
})


// WEBPACK FOOTER //
// ./src/store/index.js